import React, { useState } from 'react';
import { FaCheckCircle, FaCalendarAlt, FaUserTie, FaMapMarkerAlt, FaStar, FaMoneyBillWave } from 'react-icons/fa';
import Img from '../../assest/blogsteam.png';
import { useSelector } from 'react-redux';

// Translation objects
const translations = {
  gb: {
    title: "Our Completed Projects",
    subtitle: "Landmark infrastructure projects that set new industry standards",
    completed: "Completed",
    viewCaseStudy: "View Case Study",
    exploreAll: "Explore All Completed Projects",
    projectDescription: "Project Description",
    keyDetails: "Key Details",
    location: "Location",
    client: "Client",
    completion: "Completion",
    budget: "Budget",
    clientRating: "Client Rating",
    projectHighlights: "Project Highlights",
    challengesOvercome: "Challenges Overcome",
    notableAchievements: "Notable Achievements",
    close: "Close",
    downloadFullCaseStudy: "Download Full Case Study"
  },
  sa: {
    title: "مشاريعنا المكتملة",
    subtitle: "مشاريع البنية التحتية البارزة التي وضعت معايير جديدة للصناعة",
    completed: "مكتمل",
    viewCaseStudy: "عرض دراسة الحالة",
    exploreAll: "استكشف جميع المشاريع المكتملة",
    projectDescription: "وصف المشروع",
    keyDetails: "تفاصيل رئيسية",
    location: "الموقع",
    client: "العميل",
    completion: "تاريخ الانتهاء",
    budget: "الميزانية",
    clientRating: "تقييم العميل",
    projectHighlights: "أبرز المشروع",
    challengesOvercome: "التحديات التي تم التغلب عليها",
    notableAchievements: "الإنجازات البارزة",
    close: "إغلاق",
    downloadFullCaseStudy: "تحميل دراسة الحالة الكاملة"
  },
  fr: {
    title: "Nos Projets Terminés",
    subtitle: "Projets d'infrastructure marquants qui établissent de nouvelles normes industrielles",
    completed: "Terminé",
    viewCaseStudy: "Voir l'Étude de Cas",
    exploreAll: "Explorer Tous les Projets Terminés",
    projectDescription: "Description du Projet",
    keyDetails: "Détails Clés",
    location: "Emplacement",
    client: "Client",
    completion: "Achèvement",
    budget: "Budget",
    clientRating: "Évaluation du Client",
    projectHighlights: "Points Forts du Projet",
    challengesOvercome: "Défis Surmontés",
    notableAchievements: "Réalisations Notables",
    close: "Fermer",
    downloadFullCaseStudy: "Télécharger l'Étude de Cas Complète"
  },
  de: {
    title: "Unsere Abgeschlossenen Projekte",
    subtitle: "Meilenstein-Infrastrukturprojekte, die neue Industriestandards setzen",
    completed: "Abgeschlossen",
    viewCaseStudy: "Fallstudie Ansehen",
    exploreAll: "Alle Abgeschlossenen Projekte Erkunden",
    projectDescription: "Projektbeschreibung",
    keyDetails: "Schlüsseldetails",
    location: "Standort",
    client: "Kunde",
    completion: "Fertigstellung",
    budget: "Budget",
    clientRating: "Kundenbewertung",
    projectHighlights: "Projekthöhepunkte",
    challengesOvercome: "Überwundene Herausforderungen",
    notableAchievements: "Bemerkenswerte Leistungen",
    close: "Schließen",
    downloadFullCaseStudy: "Vollständige Fallstudie Herunterladen"
  }
};

const completedProjects = [
  {
    id: 1,
    title: {
      gb: "Riyadh Metro Station",
      sa: "محطة مترو الرياض",
      fr: "Station de Métro de Riyad",
      de: "Riyadh Metro Station",
    },
    description: {
      gb: "Construction of 12 metro stations with advanced passenger facilities and smart transportation systems across the capital city, featuring cutting-edge design and sustainable materials.",
      sa: "بناء 12 محطة مترو مع مرافق راقية للركاب وأنظمة نقل ذكية في جميع أنحاء العاصمة، بتصميم حديث ومواد مستدامة.",
      fr: "Construction de 12 stations de métro avec des installations passagers avancées et des systèmes de transport intelligents à travers la capitale, avec un design de pointe et des matériaux durables.",
      de: "Bau von 12 U-Bahn-Stationen mit modernen Fahrgasteinrichtungen und intelligenten Verkehrssystemen in der gesamten Hauptstadt, mit hochmodernem Design und nachhaltigen Materialien.",
    },
    location: {
      gb: "Riyadh, KSA",
      sa: "الرياض، المملكة العربية السعودية",
      fr: "Riyad, Arabie Saoudite",
      de: "Riad, Saudi-Arabien",
    },
    client: {
      gb: "Arriyadh Development Authority",
      sa: "هيئة تطوير مدينة الرياض",
      fr: "Autorité de Développement d'Arriyadh",
      de: "Arriyadh Entwicklungsbehörde",
    },
    year: "2021",
    duration: {
      gb: "3 Years",
      sa: "3 سنوات",
      fr: "3 Ans",
      de: "3 Jahre",
    },
    budget: "SAR 2.8B",
    rating: 4.8,
    challenges: {
      gb: "Complex underground construction in urban area",
      sa: "بناء تحت الأرض المعقد في منطقة حضرية",
      fr: "Construction souterraine complexe en zone urbaine",
      de: "Komplexer unterirdischer Bau in städtischem Gebiet",
    },
    achievements: {
      gb: "Completed 2 months ahead of schedule",
      sa: "تم الانتهاء قبل شهرين من الموعد المحدد",
      fr: "Terminé avec 2 mois d'avance",
      de: "2 Monate vor dem Zeitplan abgeschlossen",
    },
  },
  {
    id: 2,
    title: {
      gb: "Dubai Coastal Highway",
      sa: "الطريق السريع الساحلي في دبي",
      fr: "Autoroute Côtière de Dubaï",
      de: "Dubai Küstenautobahn",
    },
    description: {
      gb: "A 25-km coastal highway with integrated smart traffic systems and eco-friendly drainage solutions, enhancing connectivity across Dubai's shoreline.",
      sa: "طريق ساحلي بطول 25 كم مع أنظمة مرور ذكية مدمجة وحلول تصريف صديقة للبيئة، مما يعزز الربط على طول ساحل دبي.",
      fr: "Une autoroute côtière de 25 km avec des systèmes de trafic intelligents intégrés et des solutions de drainage écologiques, améliorant la connectivité le long du littoral de Dubaï.",
      de: "Eine 25 km lange Küstenautobahn mit integrierten intelligenten Verkehrssystemen und umweltfreundlichen Entwässerungslösungen, die die Konnektivität entlang der Küste Dubais verbessert.",
    },
    location: {
      gb: "Dubai, UAE",
      sa: "دبي، الإمارات العربية المتحدة",
      fr: "Dubaï, Émirats Arabes Unis",
      de: "Dubai, Vereinigte Arabische Emirate",
    },
    client: {
      gb: "Dubai Roads and Transport Authority",
      sa: "هيئة الطرق والمواصلات في دبي",
      fr: "Autorité des Routes et des Transports de Dubaï",
      de: "Dubai Straßen- und Verkehrsbehörde",
    },
    year: "2020",
    duration: {
      gb: "2.5 Years",
      sa: "2.5 سنة",
      fr: "2,5 Ans",
      de: "2,5 Jahre",
    },
    budget: "AED 1.5B",
    rating: 4.6,
    challenges: {
      gb: "High traffic management during construction",
      sa: "إدارة حركة المرور العالية أثناء البناء",
      fr: "Gestion du trafic intense pendant la construction",
      de: "Hohe Verkehrssteuerung während des Baus",
    },
    achievements: {
      gb: "Reduced travel time by 20% for coastal commuters",
      sa: "تقليل زمن السفر بنسبة 20% للمسافرين على الساحل",
      fr: "Réduction du temps de trajet de 20 % pour les usagers côtiers",
      de: "Reduzierte Reisezeit um 20% für Küstenpendler",
    },
  },
  {
    id: 3,
    title: {
      gb: "Jeddah Waterfront Redevelopment",
      sa: "إعادة تطوير واجهة جدة البحرية",
      fr: "Réaménagement du Front de Mer de Djeddah",
      de: "Neugestaltung der Jeddah Uferpromenade",
    },
    description: {
      gb: "Revitalization of Jeddah's waterfront with public parks, recreational facilities, and sustainable urban design, attracting millions of visitors annually.",
      sa: "إعادة تنشيط واجهة جدة البحرية مع حدائق عامة ومرافق ترفيهية وتصميم حضري مستدام، يجذب ملايين الزوار سنويًا.",
      fr: "Revitalisation du front de mer de Djeddah avec des parcs publics, des installations récréatives et un design urbain durable, attirant des millions de visiteurs par an.",
      de: "Revitalisierung der Jeddah Uferpromenade mit öffentlichen Parks, Freizeiteinrichtungen und nachhaltigem städtebaulichem Design, das jährlich Millionen von Besuchern anzieht.",
    },
    location: {
      gb: "Jeddah, KSA",
      sa: "جدة، المملكة العربية السعودية",
      fr: "Djeddah, Arabie Saoudite",
      de: "Jeddah, Saudi-Arabien",
    },
    client: {
      gb: "Jeddah Municipality",
      sa: "أمانة جدة",
      fr: "Municipalité de Djeddah",
      de: "Jeddah Gemeinde",
    },
    year: "2022",
    duration: {
      gb: "2 Years",
      sa: "سنتان",
      fr: "2 Ans",
      de: "2 Jahre",
    },
    budget: "SAR 1.2B",
    rating: 4.9,
    challenges: {
      gb: "Balancing urban development with environmental preservation",
      sa: "تحقيق التوازن بين التطوير الحضري والحفاظ على البيئة",
      fr: "Équilibrer le développement urbain avec la préservation de l'environnement",
      de: "Ausgleich zwischen städtischer Entwicklung und Umweltschutz",
    },
    achievements: {
      gb: "Awarded Green Urban Design Award 2022",
      sa: "حصل على جائزة التصميم الحضري الأخضر 2022",
      fr: "Récompensé par le Prix du Design Urbain Vert 2022",
      de: "Ausgezeichnet mit dem Green Urban Design Award 2022",
    },
  },
  {
    id: 4,
    title: {
      gb: "Abu Dhabi Solar Farm",
      sa: "مزرعة أبوظبي الشمسية",
      fr: "Ferme Solaire d'Abou Dhabi",
      de: "Abu Dhabi Solarfarm",
    },
    description: {
      gb: "A 1.2 GW solar farm delivering clean energy to thousands of households, incorporating advanced photovoltaic technology and energy storage systems.",
      sa: "مزرعة شمسية بقدرة 1.2 جيجاوات توفر الطاقة النظيفة لآلاف الأسر، باستخدام تكنولوجيا الخلايا الكهروضوئية المتقدمة وأنظمة تخزين الطاقة.",
      fr: "Une ferme solaire de 1,2 GW fournissant de l'énergie propre à des milliers de foyers, intégrant une technologie photovoltaïque avancée et des systèmes de stockage d'énergie.",
      de: "Ein 1,2 GW Solarpark, der Tausenden von Haushalten saubere Energie liefert, mit fortschrittlicher Photovoltaiktechnologie und Energiespeichersystemen.",
    },
    location: {
      gb: "Abu Dhabi, UAE",
      sa: "أبوظبي، الإمارات العربية المتحدة",
      fr: "Abou Dhabi, Émirats Arabes Unis",
      de: "Abu Dhabi, Vereinigte Arabische Emirate",
    },
    client: {
      gb: "Emirates Water and Electricity Company",
      sa: "شركة مياه وكهرباء الإمارات",
      fr: "Compagnie de l'Eau et de l'Électricité des Émirats",
      de: "Emirates Wasser- und Elektrizitätsgesellschaft",
    },
    year: "2023",
    duration: {
      gb: "1.5 Years",
      sa: "1.5 سنة",
      fr: "1,5 Ans",
      de: "1,5 Jahre",
    },
    budget: "AED 900M",
    rating: 4.7,
    challenges: {
      gb: "Extreme desert temperatures impacting equipment",
      sa: "درجات الحرارة الصحراوية القصوى التي أثرت على المعدات",
      fr: "Températures désertiques extrêmes affectant l'équipement",
      de: "Extreme Wüstentemperaturen, die die Ausrüstung beeinträchtigten",
    },
    achievements: {
      gb: "Achieved 98% energy efficiency in first year",
      sa: "حققت كفاءة طاقة بنسبة 98% في السنة الأولى",
      fr: "Atteint une efficacité énergétique de 98 % la première année",
      de: "Erreichte im ersten Jahr eine Energieeffizienz von 98%",
    },
  },
  {
    id: 5,
    title: {
      gb: "Dammam Industrial Complex",
      sa: "مجمع الدمام الصناعي",
      fr: "Complexe Industriel de Dammam",
      de: "Dammam Industriekomplex",
    },
    description: {
      gb: "Development of a 50-hectare industrial complex with state-of-the-art manufacturing facilities and logistics hubs to support regional economic growth.",
      sa: "تطوير مجمع صناعي بمساحة 50 هكتارًا مع مرافق تصنيع متطورة ومراكز لوجستية لدعم النمو الاقتصادي الإقليمي.",
      fr: "Développement d'un complexe industriel de 50 hectares avec des installations de fabrication de pointe et des centres logistiques pour soutenir la croissance économique régionale.",
      de: "Entwicklung eines 50 Hektar großen Industriekomplexes mit hochmodernen Fertigungsanlagen und Logistikzentren zur Unterstützung des regionalen Wirtschaftswachstums.",
    },
    location: {
      gb: "Dammam, KSA",
      sa: "الدمام، المملكة العربية السعودية",
      fr: "Dammam, Arabie Saoudite",
      de: "Dammam, Saudi-Arabien",
    },
    client: {
      gb: "Saudi Industrial Development Fund",
      sa: "صندوق التنمية الصناعية السعودي",
      fr: "Fonds de Développement Industriel Saoudien",
      de: "Saudi-Industriefonds",
    },
    year: "2019",
    duration: {
      gb: "4 Years",
      sa: "4 سنوات",
      fr: "4 Ans",
      de: "4 Jahre",
    },
    budget: "SAR 3.5B",
    rating: 4.5,
    challenges: {
      gb: "Coordination of multiple subcontractors across large site",
      sa: "تنسيق العديد من المقاولين الفرعيين عبر موقع كبير",
      fr: "Coordination de multiples sous-traitants sur un grand site",
      de: "Koordination mehrerer Subunternehmer auf großem Gelände",
    },
    achievements: {
      gb: "Created 5,000 direct jobs in the region",
      sa: "خلق 5000 وظيفة مباشرة في المنطقة",
      fr: "Création de 5 000 emplois directs dans la région",
      de: "Schaffung von 5.000 direkten Arbeitsplätzen in der Region",
    },
  },
  {
    id: 6,
    title: {
      gb: "Qatar Smart City Infrastructure",
      sa: "البنية التحتية للمدينة الذكية في قطر",
      fr: "Infrastructure de Ville Intelligente du Qatar",
      de: "Qatar Smart City Infrastruktur",
    },
    description: {
      gb: "Implementation of smart city infrastructure including IoT-enabled utilities, sustainable buildings, and advanced public transport systems for a futuristic urban experience.",
      sa: "تنفيذ بنية تحتية لمدينة ذكية تشمل مرافق مزودة بإنترنت الأشياء، مبانٍ مستدامة، وأنظمة نقل عام متطورة لتجربة حضرية مستقبلية.",
      fr: "Mise en œuvre d'une infrastructure de ville intelligente incluant des utilitaires compatibles IoT, des bâtiments durables et des systèmes de transport public avancés pour une expérience urbaine futuriste.",
      de: "Umsetzung einer Smart-City-Infrastruktur mit IoT-fähigen Versorgungsunternehmen, nachhaltigen Gebäuden und fortschrittlichen öffentlichen Verkehrssystemen für ein futuristisches urbanes Erlebnis.",
    },
    location: {
      gb: "Doha, Qatar",
      sa: "الدوحة، قطر",
      fr: "Doha, Qatar",
      de: "Doha, Katar",
    },
    client: {
      gb: "Qatar Public Works Authority",
      sa: "هيئة الأشغال العامة في قطر",
      fr: "Autorité des Travaux Publics du Qatar",
      de: "Katar Behörde für öffentliche Arbeiten",
    },
    year: "2024",
    duration: {
      gb: "3.5 Years",
      sa: "3.5 سنة",
      fr: "3,5 Ans",
      de: "3,5 Jahre",
    },
    budget: "QAR 2.1B",
    rating: 4.9,
    challenges: {
      gb: "Integration of IoT systems with existing infrastructure",
      sa: "دمج أنظمة إنترنت الأشياء مع البنية التحتية الحالية",
      fr: "Intégration des systèmes IoT avec l'infrastructure existante",
      de: "Integration von IoT-Systemen mit bestehender Infrastruktur",
    },
    achievements: {
      gb: "Reduced carbon emissions by 15% in pilot phase",
      sa: "خفض انبعاثات الكربون بنسبة 15% في المرحلة التجريبية",
      fr: "Réduction des émissions de carbone de 15 % pendant la phase pilote",
      de: "Reduzierung der Kohlenstoffemissionen um 15% in der Pilotphase",
    },
  },
];

const Completed = () => {
  const { language } = useSelector((state) => state.language);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const t = translations[language] || translations['gb']; // Default to English if language not found

  const handleViewCaseStudy = (project) => {
    setSelectedProject(project);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Helper function to get translated field
  const getTranslatedField = (field) => {
    if (typeof field === 'object') {
      return field[language] || field['gb'];
    }
    return field;
  };

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h2 className="text-danger fw-bold display-5">
          <FaCheckCircle className="me-2" />
          {t.title}
        </h2>
        <p className="lead text-muted">{t.subtitle}</p>
        <div className="d-flex justify-content-center">
          <div className="border-bottom border-danger border-3" style={{width: '100px'}}></div>
        </div>
      </div>

      <div className="row g-4">
        {completedProjects.map(project => (
          <div key={project.id} className="col-md-6 col-lg-4">
            <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden hover-scale">
              <div className="position-relative">
                <div className="ratio ratio-16x9">
                  <img 
                    src={Img} 
                    alt={getTranslatedField(project.title)} 
                    className="object-fit-cover"
                  />
                </div>
                <div className="position-absolute top-0 end-0 bg-danger text-white px-3 py-1 rounded-bl">
                  {t.completed}
                </div>
              </div>
              
              <div className="card-body">
                <h5 className="card-title fw-bold text-dark">{getTranslatedField(project.title)}</h5>
                <p className="card-text text-muted small">{getTranslatedField(project.description)}</p>
                
                <div className="d-flex align-items-center mb-3">
                  <div className="text-warning me-2">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className={i < Math.floor(project.rating) ? 'text-warning' : 'text-muted'} />
                    ))}
                  </div>
                  <small className="text-muted">{project.rating}/5 {t.clientRating}</small>
                </div>
                
                <ul className="list-unstyled small mb-0">
                  <li className="mb-2 d-flex align-items-center">
                    <FaMapMarkerAlt className="text-danger me-2 flex-shrink-0" />
                    <span>{getTranslatedField(project.location)}</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <FaUserTie className="text-danger me-2 flex-shrink-0" />
                    <span>{getTranslatedField(project.client)}</span>
                  </li>
                  <li className="mb-2 d-flex align-items-center">
                    <FaCalendarAlt className="text-danger me-2 flex-shrink-0" />
                    <span>{t.completion} {project.year} • {getTranslatedField(project.duration)}</span>
                  </li>
                  <li className="d-flex align-items-center">
                    <FaMoneyBillWave className="text-danger me-2 flex-shrink-0" />
                    <span className="fw-bold">{t.budget}: {project.budget}</span>
                  </li>
                </ul>
              </div>
              
              <div className="card-footer bg-transparent border-0 pt-0 pb-3">
                <button 
                  className="btn btn-outline-danger btn-sm rounded-pill px-3 w-100"
                  onClick={() => handleViewCaseStudy(project)}
                >
                  {t.viewCaseStudy}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-5">
        <button className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
          {t.exploreAll}
        </button>
      </div>

      {/* Case Study Modal */}
      {showModal && selectedProject && (
        <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.7)'}}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-danger text-white">
                <h5 className="modal-title fw-bold">{getTranslatedField(selectedProject.title)}</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white" 
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3 mb-md-0">
                    <div className="ratio ratio-16x9 bg-light rounded mb-3 overflow-hidden">
                      <img 
                        src={Img} 
                        alt={getTranslatedField(selectedProject.title)} 
                        className="object-fit-cover"
                      />
                    </div>
                    <h6 className="text-danger fw-bold">{t.projectDescription}</h6>
                    <p>{getTranslatedField(selectedProject.description)}</p>
                  </div>
                  <div className="col-md-6">
                    <div className="card border-0 shadow-sm mb-3">
                      <div className="card-body">
                        <h6 className="text-danger fw-bold">{t.keyDetails}</h6>
                        <ul className="list-unstyled small">
                          <li className="mb-2 d-flex">
                            <FaMapMarkerAlt className="text-danger me-2 mt-1 flex-shrink-0" />
                            <div>
                              <strong>{t.location}:</strong> {getTranslatedField(selectedProject.location)}
                            </div>
                          </li>
                          <li className="mb-2 d-flex">
                            <FaUserTie className="text-danger me-2 mt-1 flex-shrink-0" />
                            <div>
                              <strong>{t.client}:</strong> {getTranslatedField(selectedProject.client)}
                            </div>
                          </li>
                          <li className="mb-2 d-flex">
                            <FaCalendarAlt className="text-danger me-2 mt-1 flex-shrink-0" />
                            <div>
                              <strong>{t.completion}:</strong> {selectedProject.year} ({getTranslatedField(selectedProject.duration)})
                            </div>
                          </li>
                          <li className="mb-2 d-flex">
                            <FaMoneyBillWave className="text-danger me-2 mt-1 flex-shrink-0" />
                            <div>
                              <strong>{t.budget}:</strong> {selectedProject.budget}
                            </div>
                          </li>
                          <li className="d-flex">
                            <FaStar className="text-danger me-2 mt-1 flex-shrink-0" />
                            <div>
                              <strong>{t.clientRating}:</strong> {selectedProject.rating}/5
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="card border-0 shadow-sm">
                      <div className="card-body">
                        <h6 className="text-danger fw-bold">{t.projectHighlights}</h6>
                        <div className="mb-3">
                          <h6 className="small fw-bold">{t.challengesOvercome}</h6>
                          <p className="small">{getTranslatedField(selectedProject.challenges)}</p>
                        </div>
                        <div>
                          <h6 className="small fw-bold">{t.notableAchievements}</h6>
                          <p className="small">{getTranslatedField(selectedProject.achievements)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  className="btn btn-outline-secondary" 
                  onClick={handleCloseModal}
                >
                  {t.close}
                </button>
                <button className="btn btn-danger">
                  {t.downloadFullCaseStudy}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Completed;